export default function(a, x) {
  var lo = 0, hi = a.length;
  while (lo < hi) {
    var mid = lo + hi >>> 1;
    if (a[mid] < x) lo = mid + 1;
    else hi = mid;
  }
  return lo;
}



//////////////////
// WEBPACK FOOTER
// ./~/topojson-client/src/bisect.js
// module id = 162
// module chunks = 0